const STATUS_LABELS = {
  400: 'Requête invalide',
  401: 'Authentification requise',
  403: 'Accès refusé',
  404: 'Ressource introuvable',
  409: 'Conflit',
  500: 'Erreur interne du serveur',
  502: 'Service externe en erreur',
  503: 'Service indisponible',
  504: 'Service externe trop long à répondre',
};

const CLIENT_ERRORS = {
  FETCH_ERROR: 'Impossible de joindre le serveur (erreur réseau)',
  TIMEOUT_ERROR: 'Le serveur a mis trop de temps à répondre',
  PARSING_ERROR: 'Réponse du serveur illisible',
};

/**
 * Format an RTK Query error to display the real status and the real message of the API
 * @param {object} error - error returned by an RTK Query hook or mutation
 * @returns {{ status: number|string, title: string, message: string }}
 */
export const formatApiError = (error) => {
  if (!error) return { status: '', title: '', message: '' };

  // Errors without HTTP response (network, timeout, invalid JSON)
  if (typeof error.status === 'string') {
    const status = error.originalStatus ?? error.status;
    return {
      status,
      title: CLIENT_ERRORS[error.status] ?? 'Erreur',
      message:
        error.error ?? (typeof error.data === 'string' ? error.data : ''),
    };
  }

  const { status, data } = error;
  const apiMessage = Array.isArray(data?.message)
    ? data.message.join(', ')
    : data?.message ?? (typeof data === 'string' ? data : data?.error);

  return {
    status,
    title: STATUS_LABELS[status] ?? 'Erreur',
    message: apiMessage ?? '',
  };
};

/**
 * Build a one line message "Erreur <status> : <message>" from an RTK Query error
 * @param {object} error - error returned by an RTK Query hook or mutation
 * @returns {string}
 */
export const getApiErrorMessage = (error) => {
  const { status, title, message } = formatApiError(error);
  return `Erreur ${status} : ${message || title}`;
};
